import React from 'react';
import H2HeaderText from '../../ui/typography/H2HeaderText';
import PricingCard from '../../ui/cards/PricingCard';
import BaseText from '../../ui/typography/BaseText';
import { PAGES_ENDPOINTS } from '../../../constants/pages-endpoints';
import { PACKAGE_PRICE_FOR_RENDER } from '../../../constants/enum';
export default function RemoteCompanyIncorporation() {
  const cards = [
    {
      title: 'Basic',
      price: `$${PACKAGE_PRICE_FOR_RENDER?.BASIC}`,
      currency: 'USD',
      // info: 'Only for Hong Kong residents',
      info: [<span className="text-blue-500">Only for Hong Kong residents</span>],

      items: [
        {
          heading: 'Incorporation',
          points: [
            'Preparation of incorporation documents',
            'Business registration certificate',
            'Preparation of statutory registers'
          ]
        }
      ],
      path: PAGES_ENDPOINTS?.GET_STARTED_BASIC
    },
    {
      weRecommend: true,
      title: 'All-Inclusive',
      price: `$${PACKAGE_PRICE_FOR_RENDER?.ALL_INCLUSIVE}`,
      currency: 'USD',
      info: '$560 USD government fees INCLUDED',
      items: [
        {
          heading: 'Incorporation',
          points: [
            'Preparation of incorporation documents',
            'Business registration certificate',
            'Preparation of statutory registers'
          ]
        },
        {
          heading: 'Business Account Opening',
          points: [
            <span>
              Online bank account opening assistance with our banking partners{' '}
              {/* <span className="text-orange-500" href="#logo-section">
                Statrys, Airwallex, Currenxie and others.
              </span> */}
              <span className="text-orange-500">
                <a href="#logo-section">Statrys, Airwallex, Currenxie and others.</a>
              </span>
            </span>,
            'Certification of documents for bank account opening'
          ]
        },
        {
          heading: 'Company Secretary Services',
          headingBottomText: '(for 1 year)',
          points: [
            'Company’s registered address',
            'Company Secretary/Designated Representative',
            'Annual General Meeting Resolutions',
            'Annual Returns and corporate tax fillings'
          ]
        },
        {
          heading: 'Free Business Templates',
          points: ['All you need to run your new registered business. See below']
        }
      ],
      path: PAGES_ENDPOINTS?.GET_STARTED_ALL_INCLUSIVE
    },
    {
      title: 'Expert',
      price: `$${PACKAGE_PRICE_FOR_RENDER?.EXPERT}`,
      currency: 'USD',
      info: '$560 USD government fees INCLUDED',
      items: [
        {
          heading: '1h Incorporation',
          points: ['All services in All-Inclusive Plan']
        },
        {
          heading: 'Business Account Opening',
          points: ['All services in All-Inclusive Plan']
        },
        {
          heading: 'Company Secretary Services',
          headingBottomText: '(for 1 year)',
          points: ['All services in All-Inclusive Plan']
        },
        {
          heading: 'Free Business Templates',
          points: ['All you need to run your newly registered company. See below']
        },
        {
          headingTopText: <span className="text-blue-500">PLUS</span>,
          heading: <span className="text-bold">Legal and Tax Essentials</span>,
          points: [
            <span className="text-bold">Certificate of Incumbency issued by our partner law firm in HK</span>,
            <span className="text-bold">5 hours legal and tax free consulting</span>
          ]
        }
      ],
      path: PAGES_ENDPOINTS?.GET_STARTED_EXPERT
    }
  ];

  return (
    <div className="global-max-width-wrapper px-6 lg:px-8 xl:px-0 mx-auto">
      <div className="mt-24">
        <H2HeaderText
          fontWeight="text-regular"
          className="mt-32"
          textAlign="text-center"
          title={'100% remote Company Incorporation'}
        />
        <BaseText
          fontWeight="text-regular"
          textAlign="text-center"
          fontSize="23px"
          className="md:whitespace-pre-line mt-4 mb-16"
          title={`Hong Kong company registration with a reliable, simple and \ntransparent pricing`}
        />
        <div className="flex flex-col md:flex-row items-start gap-8" id="plan-section">
          {cards.map((cardDetails) => (
            <PricingCard
              weRecommend={cardDetails?.weRecommend}
              title={cardDetails.title}
              price={cardDetails?.price}
              currency={cardDetails?.currency}
              info={cardDetails?.info}
              heading={cardDetails?.heading}
              items={cardDetails.items}
              path={cardDetails?.path}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
